export enum ScreenName {
  CART = 'CART',
  IDLE = 'IDLE',
  LOGIN = 'LOGIN',
  PAYMENT = 'PAYMENT',
  SEND_RECEIPT = 'SEND_RECEIPT',
}
